<template>
  <div>
    <DashLineWrapper @click.stop.self.prevent :custom_style="itemStyle">
      <div
        v-for="direction in directions"
        :key="direction"
        @mouseover="initMouseOver(direction)"
        :ref="direction"
        :class="direction"
      >
        <ToolLabel
          class="label"
          v-if="mode == reheight_mode && resizePaddingActive == direction"
          style="white-space: nowrap;"
        >
          Padding: {{ padding }}
        </ToolLabel>
      </div>
    </DashLineWrapper>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DashLineWrapper, ToolLabel } from "./RePadding.styled.js";
export default {
  data() {
    return {
      directions: ["left", "right", "top", "bottom"],
      reheight_mode: "repadding_component",
      resizePaddingActive: undefined, // pdb | pdt | pdr | pdl
      padding: 0,
      label_position: {
        top: 0,
        left: 0,
      },
    };
  },
  components: {
    DashLineWrapper,
    ToolLabel,
  },
  props: {
    component_id: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      components: "designIframe/metadata/components",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
    }),
    item() {
      return this.components[this.component_id];
    },
    itemStyle() {
      return this.item ? this.item[this.styleDevice] : {};
    },
    styleDevice() {
      switch (this.detectDevice) {
        case "mobile":
          return "styleMobile";
        case "tablet":
          return "styleTablet";
        default:
          return "style";
      }
    },
  },
  mounted () {
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    initMouseOver(ref) {
      this.dragElement(ref);
    },
    dragElement(ref) {
      if (this.$refs[ref]) {
        this.resizePaddingActive = ref;
        this.$refs[ref][0].onmousedown = this.dragMouseDown;
      }
    },
    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      this.$store.dispatch("design/setMode", {
        mode: this.reheight_mode,
      });
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
      this.elementDrag(e);
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      if (!this.item || !this.resizePaddingActive) return;
      switch (this.resizePaddingActive) {
        case "bottom": {
          let paddingBottom = this.item[this.styleDevice].paddingBottom + this.pos2 <= 80 ? this.item[this.styleDevice].paddingBottom + this.pos2 : 80;
          this.item[this.styleDevice].paddingBottom = paddingBottom
          this.padding = this.item[this.styleDevice].paddingBottom;

          break;
        }
        case "top": {
          let paddingTop = this.item[this.styleDevice].paddingTop - this.pos2 <= 80 ? this.item[this.styleDevice].paddingTop - this.pos2 : 80;
          this.item[this.styleDevice].paddingTop = paddingTop;
          this.padding = this.item[this.styleDevice].paddingTop;

          break;
        }
        case "right": {
          let paddingRight = this.item[this.styleDevice].paddingRight + this.pos1 <= 80 ? this.item[this.styleDevice].paddingRight + this.pos1 : 80;
          this.item[this.styleDevice].paddingRight = paddingRight;
          this.padding = this.item[this.styleDevice].paddingRight;

          break;
        }
        case "left": {
          let paddingLeft = this.item[this.styleDevice].paddingLeft - this.pos1 <= 80 ? this.item[this.styleDevice].paddingLeft - this.pos1 : 80;
          this.item[this.styleDevice].paddingLeft = paddingLeft;
          this.padding = this.item[this.styleDevice].paddingLeft;

          break;
        }

        default:
          break;
      }
      this.item[this.styleDevice].paddingSync = false;
      if (this.item[this.styleDevice].paddingBottom < 0)
        this.item[this.styleDevice].paddingBottom = 0;
      if (this.item[this.styleDevice].paddingTop < 0)
        this.item[this.styleDevice].paddingTop = 0;
      if (this.item[this.styleDevice].paddingRight < 0)
        this.item[this.styleDevice].paddingRight = 0;
      if (this.item[this.styleDevice].paddingLeft < 0)
        this.item[this.styleDevice].paddingLeft = 0;

      this.$nextTick(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
      });
    },

    closeDragElement() {
      // stop moving when mouse button is released:
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      this.$store.dispatch("design/setMode", {});
      document.onmouseup = null;
      document.onmousemove = null;
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        if(this.mode == this.reheight_mode) this.closeDragElement();
      }
    },
  },
};
</script>

<style>
</style>